import { createBrowserRouter, redirect } from 'react-router-dom';
import { HelpScreen } from 'screens/Help';
import { MainScreen } from 'screens/Main';
import { LoginScreen } from 'screens/Login';
import { ContactScreen } from 'screens/Contact';
import { ProfileScreen } from 'screens/Profile/Profile';
import { ProfileEditScreen } from 'screens/Profile/Edit';
import { ProfileScreen as ProfileRoot } from 'screens/Profile';
import { NotFoundScreen } from 'screens/NotFound';
import { ImpactScoreScreen } from 'screens/ImpactScore';
import { LandingScreen } from 'screens/Landing';
import { RecommendationsScreen } from 'screens/Recommendations';
import { SummaryScreen } from 'screens/Summary';
import { DECheckoutScreen } from 'screens/Checkout';
import { SetScreen } from 'screens/Set';
import { GalleryScreen } from 'screens/Gallery';
import { GetStartedScreen } from 'screens/GetStarted';
import { GetStartedBackupScreen } from 'screens/GetStarted/Backup';
import { GetStartedBackup2Screen } from 'screens/GetStarted/Backup2';
import { FormsScreen } from 'screens/Forms';
import { ImpactReportScreen } from 'screens/ImpactReport';
import { AboutScreen } from 'screens/About';
import { SearchScreen } from 'screens/Search';
import { AutopilotScreen } from 'screens/Autopilot';
import { CartScreen } from 'screens/Cart';
import { PostScreen } from 'screens/Post';
import { HundredMScreen } from 'screens/HundredM';
import { RouteErrorElement } from './RouteErrorElement';

export const router = createBrowserRouter([
  {
    // Logs every route error; a per-route errorElement would bypass it.
    errorElement: <RouteErrorElement />,
    children: [
      {
        path: '/',
        element: <LandingScreen />,
      },
      {
        path: '/error',
        element: <NotFoundScreen />,
      },
      {
        path: '/impact_score',
        element: <ImpactScoreScreen />,
      },
      {
        path: '/login',
        element: <LoginScreen />,
      },
      {
        path: '/donor',
        element: <AboutScreen />,
      },
      {
        path: '/help',
        element: <HelpScreen />,
      },
      {
        path: '/contact',
        element: <ContactScreen />,
      },
      {
        path: '/donate/*',
        element: <MainScreen />,
        children: [
          {
            path: '', // main donate page
          },
          {
            path: 'checkout/*', // checkout page, used only for DAF for now
            children: [
              {
                path: 'daf', // DAF checkout page
              },
              {
                path: 'standard',
              },
            ],
          },
          {
            path: 'confirmation/:paymentMethod', // confirmation page, used only for DAF for now
          },
        ],
      },
      {
        path: '/profile',
        element: <ProfileRoot />,
        children: [
          {
            path: '',
            element: <ProfileScreen />,
          },
          {
            path: 'edit',
            element: <ProfileEditScreen />,
          },
        ],
      },
      {
        path: '/recommendations',
        element: <RecommendationsScreen />,
      },
      {
        path: '/summary',
        element: <SummaryScreen />,
      },
      {
        path: '/set',
        element: <SetScreen />,
      },
      {
        path: '/monthly',
        loader: () => redirect('/autopilot'),
      },
      {
        path: '/gallery',
        element: <GalleryScreen />,
      },
      {
        path: '/getstarted',
        element: <GetStartedScreen />,
      },
      {
        path: '/getstarted-032026',
        element: <GetStartedBackupScreen />,
      },
      {
        path: '/getstarted-062026',
        element: <GetStartedBackup2Screen />,
      },
      {
        path: '/impact_report',
        element: <ImpactReportScreen />,
      },
      {
        path: '/forms/:form',
        element: <FormsScreen />,
      },
      {
        path: '/checkout/*', // checkout page used for Democracy Engine
        element: <DECheckoutScreen />,
        children: [
          {
            path: '',
          },
          {
            path: 'confirmation',
          },
        ],
      },
      {
        path: '/search/*',
        element: <SearchScreen />,
      },
      {
        path: '/autopilot',
        element: <AutopilotScreen />,
      },
      {
        path: '/cart',
        element: <CartScreen />,
      },
      {
        path: '/post/:id',
        element: <PostScreen />,
      },
      {
        path: '/100m',
        element: <HundredMScreen />,
      },
      {
        path: '/landing',
        loader: () => redirect('/'),
      },
      {
        path: '/questions',
        element: <NotFoundScreen />,
      },
    ],
  },
]);
